import { Form, Modal, message } from 'antd';
import axios from 'axios';
import { useEffect, useState } from 'react';

import { trimTextFields } from '../../utils/formRules';
import UserForm from './UserForm';
import useUserStore from './userStore';

/** Хадгалахын өмнө эхэн/төгсгөлийн илүү зайг цэвэрлэх текст талбарууд */
const TRIMMABLE_TEXT_FIELDS = ['lastName', 'firstName', 'email', 'description'];

/** Давхардлыг шалгахад и-мэйлээр хайхад хангалттай хэмжээ */
const EMAIL_LOOKUP_SIZE = 20;

/**
 * Тухайн и-мэйлээр ажилтан аль хэдийн бүртгэлтэй эсэхийг шалгана.
 *
 * Сервер тал бүртгэлтэй и-мэйл дээр шинэ ажилтан үүсгэхгүй атлаа HTTP 200 ба
 * «Ажилтан амжилттай бүртгэгдлээ!» гэж буцаадаг (буцаах `id` нь өмнөх ажилтны
 * id). Хэрэглэгч ажилтан бүртгэгдсэн гэж эндүүрч, нэвтрэх мэдээллийг тэр хүнд
 * дамжуулах эрсдэлтэй тул хадгалахаас ӨМНӨ жагсаалтаас шалгана.
 *
 * Шалгалт өөрөө бүтэлгүйтвэл (сүлжээ, сервер) хадгалалтыг зогсоохгүй — сервер
 * тал шийднэ.
 */
const isEmailTaken = async (email) => {
  const keyword = email?.trim().toLowerCase();
  if (!keyword) return false;

  try {
    const { data } = await axios.post('/api/1.0/users/list', {
      query: keyword,
      page: 1,
      size: EMAIL_LOOKUP_SIZE,
    });

    const docs = data?.result?.docs ?? [];
    return docs.some((doc) => doc?.email?.trim().toLowerCase() === keyword);
  } catch (e) {
    console.error('Check User Email: ', e);
    return false;
  }
};

const CreateUser = ({ visible, onCancel }) => {
  const [form] = Form.useForm();
  const refreshUserList = useUserStore((state) => state.refreshUserList);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    form.setFieldsValue({ roleCode: 'merchant-staff' });
    //eslint-disable-next-line
  }, []);

  const submitCreateUser = async () => {
    let values;
    try {
      values = await form.validateFields();
    } catch {
      return;
    }

    // Толгой/сүүлийн зайг тайрч хадгална — " Дорж " ба "Дорж" хоёр өөр нэр болохгүй
    const payload = { ...values, ...trimTextFields(values, TRIMMABLE_TEXT_FIELDS) };

    setSaving(true);
    try {
      if (await isEmailTaken(payload.email)) {
        // Талбарын доор алдаа тавина — цонх нээлттэй үлдэж, хэрэглэгч и-мэйлээ засна
        form.setFields([
          {
            name: 'email',
            errors: ['Энэ и-мэйлээр ажилтан аль хэдийн бүртгэгдсэн байна.'],
          },
        ]);
        return;
      }

      const { data } = await axios.post('/api/v1.0/users', payload);

      /**
       * Backend нь алдааг ч HTTP 200-аар буцаадаг тул биед байгаа `statusCode`-оор
       * шалгана. Алдааны тайлбарыг axios interceptor өөрөө харуулах тул цонхыг
       * хаахгүй — бөглөсөн мэдээлэл хэвээр байж, хэрэглэгч засаад дахин хадгална.
       */
      if (data?.statusCode !== 200) return;

      message.success('Ажилтан амжилттай бүртгэгдлээ.');
      refreshUserList();
      onCancel();
    } catch (e) {
      // Алдааны мэдэгдлийг interceptor гаргана — энд дахин гаргавал хоёр toast болно
      console.error('Create User: ', e);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      title="Ажилтан нэмэх"
      open={visible}
      onCancel={onCancel}
      onOk={submitCreateUser}
      okText="Хадгалах"
      cancelText="Буцах"
      confirmLoading={saving}
      maskClosable={false}
      destroyOnClose
    >
      <UserForm form={form} />
    </Modal>
  );
};

export default CreateUser;
